import React, { Fragment } from 'react';
import * as dateFns from 'date-fns';

import TimeSelector from '../../Shared/TimeSelector';
type EditableTimeProps = {
  editable: boolean;
  time: number | string;
  handleChange: (
    args_0: number, 
    args_1: number, 
    args_2: number, 
    args_3: boolean, 
    args_4?: number
  ) => void;
  index: number;
  timeIsWrong: boolean;
  rejectionMessage: string | null
}
const EditableTime = ({
  editable,
  time,
  handleChange,
  index,
  timeIsWrong,
  rejectionMessage = null }:EditableTimeProps) => {

  return (
    <Fragment>
      { editable ?
        <TimeSelector
          time={time === '' ? 0 : time as number}
          applyChanges={handleChange}
          index={index}
          customClass={timeIsWrong ? 'warning-borders' : ''}
          message={rejectionMessage || ''}
        /> :
        time === '' ? time : dateFns.format(time as number, 'hh:mm:ss') }
    </Fragment>
  );
};
export default EditableTime;
